<script lang="ts" setup>
import Popover from 'primevue/popover';
import { computed, ref } from 'vue';
import { useApplicationRoot } from '@tools/applicationRoot';
import { type VPopoverTheme, getPassthroughStyles } from './VPopover.styles';

export interface VPopoverProps {
  theme?: VPopoverTheme;
  role?: 'tooltip' | 'dialog';
}

const props = withDefaults(defineProps<VPopoverProps>(), {
  theme: 'primary',
  role: 'dialog',
});

const popover = ref();
const passthroughStyles = computed(() => getPassthroughStyles(props.role, props.theme));
const applicationroot = useApplicationRoot();

defineExpose({
  hide: () => popover.value.hide(),
  show: (event: Event) => popover.value.show(event),
  toggle: (event: Event) => popover.value.toggle(event),
  visible: computed(() => popover.value?.visible),
});
</script>

<template>
  <Popover :append-to="applicationroot" :pt="passthroughStyles" ref="popover">
    <slot></slot>
  </Popover>
</template>
